import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';

export const TurnoverRatio = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.TurnoverRatio"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label="Turnover Ratio"
          tooltip="Percentage of portfolio that is realized and taxed annually."
        />
      )}
    />
  );
};
